import React from "react";
import { Card, Avatar, Typography, Tag, Button, Space } from "antd";
import { ArrowLeftOutlined, UserOutlined, CheckCircleOutlined, StopOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const headerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  // marginBottom: 24,
};

export default function CustomerHeader({ customer, onBack }) {
  return (
    <Card style={{ marginBottom: 24, borderRadius: 8 }}>
      <div style={headerStyle}>
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <Avatar size={56} style={{ backgroundColor: "#0070D7" }}>
            {customer.name?.charAt(0)?.toUpperCase()}
          </Avatar>
          <div>
            <Title level={4} style={{ margin: 0, marginBottom: 4 }}>
              {customer.name}
            </Title>
            <Space>
              <Text type="secondary">Mã KH:</Text>
              <Tag color="blue">{customer.code}</Tag>
              <Tag
                color={customer.status ? "success" : "error"}
                icon={customer.status ? <CheckCircleOutlined /> : <StopOutlined />}
              >
                {customer.status ? "Hoạt động" : "Ngừng hoạt động"}
              </Tag>
            </Space>
          </div>
        </div>
        <Button icon={<ArrowLeftOutlined />} onClick={onBack}>
          Quay lại
        </Button>
      </div>
    </Card>
  );
}
